module.exports = __webpack_public_path__ + "img/windows_on.f1914085.png";